import { Injectable } from "@angular/core";
import { signOut, fetchUserAttributes, signInWithRedirect } from 'aws-amplify/auth';
@Injectable({
    providedIn: 'root'
})
export class AmplifyAuthService {

    constructor() {}

    signOut() {
        return signOut()
    }
    fetchUserAttributes() {
        return fetchUserAttributes()
    }
    signInWithRedirect() {
        return signInWithRedirect()
    }
}